export const PROMO_NAMES = ['betBoost', 'oddsBoost'] as const;

export type TPromoName = typeof PROMO_NAMES[number];
